import getLinkText from "../../../helpers/getLinkText";
import getSubsection from "../../../helpers/getSubsection";
import { trackEvent } from "../../../trackEvent";

/**
 * Push any header links to datalayer when they are in the .header tag
 * Basic DOM markup assumed.
 * 
 * <div class="header">
 *  <div data-gtm-subsection="social">
 *   <a href="">Facebook</a>
 *  </div>
 * </div>
 */

const test = ({ target }) => target.closest(".navigation, .navigationAlternate");

const push = ({ link, target }) => {
  trackEvent({
    event: "navigation",
    interaction_type: "navigation",
    section: "header",
    sub_section: getSubsection(target),
    element: getLinkText({ link, target })
  });
}

export default {
  name: "header",
  test,
  push
};